import * as fileSaver from "file-saver";
import { fetcher } from "common/api/Fetcher";
import { handleErrors } from "common/reducers/Utils";
import { JobRecord } from "common/records/Job";
import { DateFormat } from "common/helpers/Format";
import { Nullable } from "common/types";

// A failed per-file fetch must not trigger the global 404/403 redirect.
const noGlobalRedirect = { useGlobalNotFoundRedirect: false, useGlobalAuthRedirect: false };

export async function downloadFile(url: string, filename: string): Promise<void> {
  try {
    const response = await fetcher.fetch(url, undefined, { ...noGlobalRedirect });
    const blob = await response.blob();
    fileSaver.saveAs(blob, filename);
  } catch (error) {
    handleErrors(error);
  }
}

export async function fetchFileFromUrl(url: string, filename: string): Promise<File> {
  const response = await fetcher.fetch(url, undefined, { ...noGlobalRedirect });
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type });
}

export const buildFileName = (job: Nullable<JobRecord>, documentName: Nullable<string>): string => {
  const date = DateFormat(new Date(), "short-hyphenated").replace(":", "");
  if (documentName) {
    return `Filled ${documentName.replace(".pdf", "")} - Saved ${date}.pdf`;
  }

  return `${job?.name} - Saved ${date}.pdf`;
};

export const downloadFileName = (name: string, ignoreWhiteSpace = false): string => {
  const expression = ignoreWhiteSpace ? /[\:\+\(\)]/g : /[\s\:\+\(\)]/g;
  return name.replace(expression, "_");
};

export const exportFileToS3 = async (url: string, file: Blob | File) => {
  const response = await fetch(url, { body: file, method: "PUT", headers: { "Content-Type": file.type } });
  // A rejected presigned PUT must throw — otherwise the caller's follow-up create registers a
  // uuid whose storage object doesn't exist, and the async ingest job fails out of view.
  if (!response.ok) {
    throw response;
  }
};
